import { Smartphone } from "lucide-react";
import { usePageMeta } from "@/lib/usePageMeta";
import { useLang } from "@/lib/i18n";
import { PageIntro, Reveal } from "@/components/Reveal";

// Ajouter ici les applications publiées / Add published apps here: { name, description, platforms, url }
const APPS = [];

const AppCard = ({ app, index }) => (
  <Reveal delay={index * 0.1} className="rounded-2xl border border-line bg-white p-8" data-testid={`app-card-${index}`}>
    <h3 className="text-xl font-bold tracking-tight text-navy">{app.name}</h3>
    <p className="mt-3 text-sm leading-relaxed text-muted">{app.description}</p>
    <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-coral">{app.platforms}</p>
  </Reveal>
);

const PlaceholderCard = ({ index, label }) => (
  <Reveal
    delay={index * 0.1}
    className="group relative flex min-h-[260px] flex-col justify-between rounded-2xl border border-dashed border-line bg-white p-8 transition-colors duration-500 hover:border-brand"
    data-testid={`app-placeholder-${index}`}
  >
    <span className="grid h-12 w-12 place-items-center rounded-xl bg-cream text-muted transition-colors duration-500 group-hover:text-brand">
      <Smartphone size={22} strokeWidth={1.5} />
    </span>
    <div>
      <div className="h-3 w-2/3 rounded-full bg-cream" />
      <div className="mt-3 h-3 w-1/2 rounded-full bg-cream" />
      <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-coral">
        {label} {String(index + 1).padStart(2, "0")}
      </p>
    </div>
  </Reveal>
);

export default function Apps() {
  const { t } = useLang();
  const a = t.apps;
  usePageMeta(a.meta);

  return (
    <>
      <PageIntro eyebrow={a.eyebrow} title={a.title} subtitle={a.subtitle} testId="apps-intro" />

      <section data-testid="apps-list-section">
        <div className="container-x py-20 sm:py-28">
          <Reveal>
            <span
              className="inline-flex items-center gap-2 rounded-full border border-coral/40 bg-white px-3.5 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-coral"
              data-testid="apps-status-badge"
            >
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-coral" />
              {a.badge}
            </span>
            <p className="mt-6 max-w-xl text-xl font-medium leading-snug tracking-tight text-navy sm:text-2xl" data-testid="apps-coming-soon-text">
              {a.message}
            </p>
          </Reveal>

          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="apps-grid">
            {APPS.length > 0
              ? APPS.map((app, i) => <AppCard key={app.name} app={app} index={i} />)
              : [0, 1, 2].map((i) => <PlaceholderCard key={i} index={i} label={a.placeholder} />)}
          </div>
        </div>
      </section>
    </>
  );
}
